<template>
  <component
    :is="tagName || 'div'"
    v-if="title"
    class="title text"
    :class="[
      {
        'text-center': textCenter,
        'text-right': textRight,
        'text-left': textLeft,
        block: !inlineBlock,
        'inline-block': inlineBlock,
        description,
        titleColor2,
        titleColor,
        'text-xs': smallDetail,
        fontBold: bold,
        'text-sm': textSm,
        'text-md': textMd,
        'text-lg': textLg,
        'text-xl': textXl,
        'text-2xl': text2Xl,
        primaryText,
        blueText,
        'text-white': white,
        whiteBlueText: whiteBlue,
        normalColor,
        blackText,
        grayText,
        overflowEllipsis,
        ellipsisWithoutDots,
        specific,
      },
      color,
    ]"
    :style="{ 'font-family': fontFaimly || 'inherit' }"
  >
    <slot></slot>
  </component>
  <component
    :is="tagName || 'span'"
    v-else
    class="text"
    :class="[
      {
        'text-center': textCenter,
        'text-right': textRight,
        'text-left': textLeft,
        block,
        'inline-block': inlineBlock,
        titleColor2,
        titleColor,
        description,
        'text-xs': smallDetail,
        fontBold: bold,
        'text-sm': textSm,
        'text-md': textMd,
        'text-lg': textLg,
        'text-xl': textXl,
        'text-2xl': text2Xl,
        primaryText,
        blueText,
        'text-white': white,
        whiteBlueText: whiteBlue,
        normalColor,
        blackText,
        grayText,
        overflowEllipsis,
        ellipsisWithoutDots,
        specific,
      },
      color,
    ]"
    :style="{ 'font-family': fontFaimly || 'inherit' }"
  >
    <slot></slot>
  </component>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "TextComponent",
  props: {
    title: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    inlineBlock: {
      type: Boolean,
      default: false,
    },
    textRight: {
      type: Boolean,
      default: false,
    },
    textLeft: {
      type: Boolean,
      default: false,
    },
    textCenter: {
      type: Boolean,
      default: false,
    },
    description: {
      type: Boolean,
      default: false,
    },
    smallDetail: {
      type: Boolean,
      default: false,
    },
    textLg: {
      type: Boolean,
      default: false,
    },
    textXl: {
      type: Boolean,
      default: false,
    },
    text2Xl: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    normalColor: {
      type: Boolean,
      default: false,
    },
    primaryText: {
      type: Boolean,
      default: false,
    },
    blueText: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    whiteBlue: {
      type: Boolean,
      default: false,
    },
    textSm: {
      type: Boolean,
      default: false,
    },
    textMd: {
      type: Boolean,
      default: false,
    },
    blackText: {
      type: Boolean,
      default: false,
    },
    grayText: {
      type: Boolean,
      default: false,
    },
    overflowEllipsis: {
      type: Boolean,
      default: false,
    },
    ellipsisWithoutDots: {
      type: Boolean,
      default: false,
    },
    specific: {
      type: Boolean,
      default: false,
    },
    titleColor2: {
      type: Boolean,
      default: false,
    },
    titleColor: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    fontFaimly: {
      type: String,
      default: "",
    },
    tagName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  --primary-color: #171717;
  --title-color: #4c4b4d;
  --title-color: var(--colors-primary);
  --normal-color: #afadb3;
  --title-color-2: #3f4e60;
  --blue-color: #171717;
  --normal-color: #afadb3;
  --description-color: #ABB3B0;
  --white-color: white;
  --whiteBlue-color: #171717;
  --black-color: #171717;
  --gray-color: #171717;
}

.text {
  /* color: var(--normal-color); */
  font-weight: 500 !important;
}

.overflowEllipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.title {
  color: var(--title-color);
  font-size: 20px;
  font-weight: 600 !important;
}

.titleColor {
  color: var(--title-color);
}

.description {
  color: var(--description-color);
}

.normalColor {
  color: var(--normal-color);
}

.fontBold {
  font-weight: 600 !important;
}

.specific {
  font-size: 10px !important;
  font-weight: 900 !important;
}
</style>